const Fonts = {
    Text: {
        h1: 'AvenirRegular, sans-serif',
        h2: 'AvenirBlack, sans-serif',
        h3: 'AvenirRegular, sans-serif',
        h4: 'AvenirRegular, sans-serif',
        p: 'CenturyGothic, sans-serif',
        sub: 'FuturaDemiBold, sans-serif',
    },
};

export { Fonts };
